import React, { createContext, useContext, useState } from 'react';
import { fetchPostData } from '@/Components/hooks/Api';
import { threeColArray } from '@/Components/Common/ChangeArrayFormat';

const PropertyContext = createContext();

export const PropertyProvider = ({ children }) => {
  const [propertyData, setPropertyData] = useState([]);
  const [propertyFilterData, setPropertyFilterData] = useState([]);
  const [propertyStolenValue, setPropertyStolenValue] = useState('');
  const [propertyTypeData, setPropertyTypeData] = useState([]);
  const [propertyLossCodeData, setPropertyLossCodeData] = useState([]);
  const [propertyStatus, setPropertyStatus] = useState(false);
  const [locationPath, setLocationPath] = useState();
  const [locationStatus, setlocationStatus] = useState(false);
  const [propertyCount, setPropertyCount] = useState('');
  const [countmiscellinfo, setcountmiscellinfo] = useState(false);
  const [BarCodeStatus, setBarCodeStatus] = useState([]);

  const get_Data_Property = (IncidentID) => {
    fetchPostData('Property/GetData_Property', { IncidentID }).then((res) => {
      setPropertyData(res || []);
      setPropertyFilterData(res || []);
    });
  };

  const get_PropertyLossCode = (
    LoginAgencyID,
    IsArticleReason,
    IsBoatReason,
    IsSecurityReason,
    IsOtherReason,
    IsDrugReason,
    IsGunReason
  ) => {
    fetchPostData('PropertyReasonCode/GetDataDropDown_PropertyReasonCode', {
      AgencyID: LoginAgencyID,
      IsArticleReason: IsArticleReason || 0,
      IsBoatReason: IsBoatReason || 0,
      IsSecurityReason: IsSecurityReason || 0,
      IsOtherReason: IsOtherReason || 0,
      IsDrugReason: IsDrugReason || 0,
      IsGunReason: IsGunReason || 0,
    }).then((data) => {
      if (data) {
        const arr = threeColArray(data, 'PropertyReasonCodeID', 'Description', 'PropertyReasonsCode');
        setPropertyLossCodeData(arr?.filter((v) => v?.id !== 'PAWN' && v?.label !== 'Pawned Property') || []);
      } else {
        setPropertyLossCodeData([]);
      }
    });
  };

  const get_Property_Count = (PropertyID, MasterPropID, IsMaster) => {
    fetchPostData('HomeApi/GetData_PropertyCount', { PropertyID, MasterPropertyID: MasterPropID, IsMaster }).then((res) => {
      setPropertyCount(res?.[0] || '');
    });
  };

  return (
    <PropertyContext.Provider
      value={{
        propertyData,
        setPropertyData,
        propertyFilterData,
        setPropertyFilterData,
        propertyStolenValue,
        setPropertyStolenValue,
        propertyTypeData,
        setPropertyTypeData,
        propertyLossCodeData,
        setPropertyLossCodeData,
        propertyStatus,
        setPropertyStatus,
        locationPath,
        setLocationPath,
        locationStatus,
        setlocationStatus,
        propertyCount,
        setPropertyCount,
        countmiscellinfo,
        setcountmiscellinfo,
        BarCodeStatus,
        setBarCodeStatus,
        get_Data_Property,
        get_PropertyLossCode,
        get_Property_Count,
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
};

export const useProperty = () => {
  const context = useContext(PropertyContext);
  if (!context) throw new Error('useProperty must be used within PropertyProvider');
  return context;
};

export default PropertyContext;
